// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseURL: 'api/rest/s1',
  baseWebSocketURL: 'api/notws',
  invoiceRegisterUrl: 'https://dangky.homecasta.vn/',
  firebaseConfig : {
    apiKey: "AIzaSyBDPuffHZxQlGtVnsZHx2PhCYc8YrnSfr0",
    authDomain: "testfirebase-68268.firebaseapp.com",
    projectId: "testfirebase-68268",
    storageBucket: "testfirebase-68268.firebasestorage.app",
    messagingSenderId: "1006534388356",
    appId: "1:1006534388356:web:4cfd548b08a62cd86d30d1",
    measurementId: "G-P96T418BWL"
  },
  vapidKey: "BBcjCZEzFiVBpJy8FL86kU3wEdUDtdeuZ4XiYDXTrRwLYHsdgOutYfRBU5QxGahP8G36_Su-WNL9irwaVTAf0Mc"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
